<footer class="app-footer">
  <span>&copy; {{ currentYear }} Affix. Todos os direitos reservados.</span>
</footer>
